import React from 'react';
import styled from 'styled-components';
import AIWebinarHero from './AIWebinarHero';
import AIWebinarFeatures from './AIWebinarFeatures';
import AIWebinarCTA from './AIWebinarCTA';

function AIWebinarPage() {
  return (
    <AIWebinarPageContainer>
      <AIWebinarHero />
      <AIWebinarFeatures />
      <AIWebinarCTA />
    </AIWebinarPageContainer>
  );
}

const AIWebinarPageContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  background-color: #0a0e17;
  color: #ffffff;
  font-family: 'Manrope', sans-serif;
`;

export default AIWebinarPage; 